import { render, staticRenderFns } from "./product_user3.vue?vue&type=template&id=58dd7fc4&scoped=true&"
import script from "./product_user3.vue?vue&type=script&lang=js&"
export * from "./product_user3.vue?vue&type=script&lang=js&"
import style0 from "./product_user3.vue?vue&type=style&index=0&id=58dd7fc4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58dd7fc4",
  null
  
)

export default component.exports